import { useEffect, useState } from "react"

export function useStable<T>(val: T, timeToStable = 250): T {
  const [stable, setStable] = useState(val)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setStable(val)
    }, timeToStable)
    return () => clearTimeout(timeout)
  }, [JSON.stringify(val)])

  return stable
}
